export const coursesLessonsSelector = (state: any) => state.coursesLessons;
